<template>
  <h4>{{ $t("tickets.ticketsSection") }}</h4>
  <p>{{ $t("tickets.ticketsSubSection") }}</p>

  <DataTable
    :value="tickets"
    :paginator="true"
    :rows="10"
    stripedRows
    v-model:filters="filters"
    filterDisplay="menu"
    :globalFilterFields="[
      'uid',
      'subject',
      'created',
      'updated',
      'closed',
      'status',
      'issue',
    ]"
    :row-hover="true"
    @row-click="goToTicketPage($event)"
    :loading="loading"
    class="custom-table-tickets"
  >
    <template #loading>
      {{ $t("tickets.loadingTicketsList") }}
    </template>
    <template #empty> {{ $t("tickets.emptyTicketsList") }}. </template>
    <template #header>
      <div class="flex justify-content-between-custom">
        <span class="p-input-icon-left">
          <InputText
            v-model="filters['global'].value"
            :placeholder="keywordSearch"
          />
        </span>
        <i
          class="pi pi-filter-slash"
          @click="clearFilter"
          style="padding-left: 10px;"
        ></i>
      </div>
    </template>
    <Column
      field="uid"
      :header="idHeader"
      headerStyle="text-align:center;"
      bodyStyle="text-align:center"
      :sortable="true"
    ></Column>
    <Column
      field="status"
      :header="statusHeader"
      bodyStyle="text-align:center"
      headerStyle="text-align:center"
    >
      <template #body="{data}">
        <Tag :severity="tagSeverity(data.status)">{{
          $t("tickets." + data.status)
        }}</Tag>
      </template>
    </Column>
    <Column
      field="created"
      :header="createdHeader"
      bodyStyle="text-align:center"
      headerStyle="text-align:center"
    ></Column>
    <Column
      field="updated"
      :header="updatedHeader"
      bodyStyle="text-align:center"
      headerStyle="text-align:center"
    ></Column>
    <Column
      field="closed"
      :header="closedHeader"
      bodyStyle="text-align:center"
      headerStyle="text-align:center"
    ></Column>
    <Column
      field="subject"
      :header="subjectHeader"
      bodyStyle="text-align:center"
      headerStyle="text-align:center"
    ></Column>
    <Column
      field="issue"
      :header="issueHeader"
      bodyStyle="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
      headerStyle="width:400px;"
    ></Column>
  </DataTable>
</template>
<script>
import TicketService from "../service/TicketService";
import { FilterMatchMode } from "primevue/api";

export default {
  data() {
    return {
      idHeader: this.$t("tickets.idHeader"),
      statusHeader: this.$t("tickets.statusHeader"),
      createdHeader: this.$t("tickets.createdHeader"),
      updatedHeader: this.$t("tickets.updatedHeader"),
      subjectHeader: this.$t("ticket.subjectHeader"),
      closedHeader: this.$t("ticket.closedHeader"),
      issueHeader: this.$t("ticket.issueHeader"),
      keywordSearch: this.$t("ticket.keywordSearch"),
      tickets: null,
      filters: null,
      loading: false,
    };
  },
  computed: {
    access_token: function() {
      return this.$store.getters["userdata/getAccessToken"];
    },
    email: function() {
      return this.$store.getters["profile/email"];
    },
  },
  created() {
    this.ticketService = new TicketService();
    this.initFilters();
  },
  async mounted() {
    this.loading = true;
    this.tickets = await this.ticketService.getTickets(
      this.access_token,
      this.email
    );
    this.formatTicketStatus(); //Alternative to get translation in service
    this.loading = false;
  },
  methods: {
    formatTicketStatus() {
      this.tickets.map((ticket) => {
        switch (ticket.status) {
          case 0:
            ticket.status = "statusNew";
            break;
          case 1:
            ticket.status = "statusOpen";
            break;
          case 2:
            ticket.status = "statusPending";
            break;
          case 3:
            ticket.status = "statusClosed";
            break;
        }
      });
    },
    clearFilter() {
      this.initFilters();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    tagSeverity(status) {
      switch (status) {
        case "statusNew":
          return "info";
        case "statusOpen":
          return "success";
        case "statusPending":
          return "warning";
        case "statusClosed":
          return "danger";
      }
    },
    goToTicketPage(event) {
      this.$router.push({
        name: "singleTicket",
        params: { uid: event.data.uid },
      });
    },
  },
};
</script>
<style scoped>
.issue-style {
  font-weight: 800;
  widows: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.p-inputtext {
  width: 100%;
  border-radius: 18px;
  border-width: 1px;
  border-color: #272728;
  padding-left: 10px;
}

.justify-content-between-custom{
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
}
</style>

<style>
.custom-table-tickets.p-datatable table{
  width:100%;
}

.custom-table-tickets .p-column-header-content{
  flex-direction: row;
  justify-content: center;
}
</style>
